var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 12.8333C23.048 10.7802 22.0956 8.87792 20.6228 7.41939C19.1499 5.96087 17.2384 5.02705 15.1826 4.76179C13.1269 4.49653 11.0409 4.91454 9.24609 5.95144C7.45126 6.98833 6.04714 8.58657 5.25002 10.5M4.66669 5.83332V10.5H9.33335M4.66669 15.1666C4.95201 17.2197 5.90444 19.122 7.37727 20.5806C8.85011 22.0391 10.7616 22.9729 12.8174 23.2382C14.8732 23.5034 16.9591 23.0854 18.754 22.0485C20.5488 21.0116 21.9529 19.4134 22.75 17.5M23.3334 22.1666V17.5H18.6667",
    stroke: "url(#paint0_linear_603_25401)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_25401",
    x1: 4.66669,
    y1: 14,
    x2: 23.3334,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.aff18d0b3405fcb2f4eb32a8c32422ef.svg";
export { ForwardRef as ReactComponent };